import { Box, Container, Spacer } from '@chakra-ui/react';
import { ChatRoomType } from 'enums/modules/chat/chatRoomType';
import SidebarLayout, {
  sidebarWidth,
} from 'presentation/layout/shared/SidebarLayout';
import { FC } from 'react';
import PersonalManagerChatCard from 'presentation/containers/modules/chat/detail/PersonalManagerChatCard';
import EventCategoriesSidebarContainer from './EventCategoriesSidebarContainer';
import EventCalendarCarouselContainer from './sections/EventCalendarCarouselContainer';
import PassedEventsByCategoryContainer from './sections/PassedEventsByCategoryContainer';
import UpcomingEventsByCategoryContainer from './sections/UpcomingEventsByCategoryContainer';

interface Props {
  categoryId: ID;
}

const EventsByCategoryContainer: FC<Props> = ({ categoryId }) => {
  return (
    <Container display="flex" alignItems="flex-start">
      <SidebarLayout>
        <EventCategoriesSidebarContainer activeCategoryId={categoryId} />
        <PersonalManagerChatCard
          mt="20px"
          roomType={ChatRoomType.CommunityManager}
        />
      </SidebarLayout>
      <Box flex="1" w={`calc(100% - ${sidebarWidth}px - 20px)`}>
        <UpcomingEventsByCategoryContainer categoryId={categoryId} />
        <EventCalendarCarouselContainer />
        <Spacer h="20px" />
        <PassedEventsByCategoryContainer categoryId={categoryId} />
      </Box>
    </Container>
  );
};

export default EventsByCategoryContainer;
